module.exports = __webpack_public_path__ + "09c6a6f6ad06efca73c83561048123bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Racers/racer_blue.png
// module id = 651
// module chunks = 0